module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Regular.e5487740.eot";